import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURSpinModel from "../models/BURSpinModel";
import BURFeatureModel from "../models/BURFeatureModel";

export class BURHasFreeSpinsCondition implements ICondition {
    public check(): boolean {
        const fsIndex = BURSpinModel.current_free_spin_index;
        if (fsIndex === -1) return false;
        return fsIndex <= BURFeatureModel.free_spins_data!.countFreeSpins - 1;
    }
}
